export type AnnouncementType = 'feature' | 'fix' | 'improvement' | 'notice' | 'security';

export interface Announcement {
  id: string;
  type: AnnouncementType;
  title: string;
  body: string;
  date: string;
  important: boolean;
  is_read: boolean;
}

export interface AnnouncementsResponse {
  data: Announcement[];
  unread_count: number;
  unread_important: Announcement[];
}

export const ANNOUNCEMENT_TYPE_CONFIG: Record<AnnouncementType, { label: string; color: string }> =
  {
    feature: { label: '機能追加', color: 'blue' },
    fix: { label: 'バグ修正', color: 'red' },
    improvement: { label: '改善', color: 'teal' },
    notice: { label: 'お知らせ', color: 'orange' },
    security: { label: 'セキュリティ', color: 'grape' },
  };
